<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iv"></a>
<p class="copyt"><em class="italic"><span class="bold">Death March Through Russia</span></em></p>
<p class="copy">This English-language edition</p>
<p class="copy">first published in 2019 by</p>
<p class="copy">Greenhill Books,</p>
<p class="copy">c/o Pen &amp; Sword Books Ltd,</p>
<p class="copy">47 Church Street, Barnsley,</p>
<p class="copy">S. Yorkshire, S70 2AS</p>
<p class="copy1"><span class="weblink"><a href="http://www.greenhillbooks.com" target="_blank"><span class="underline">www.greenhillbooks.com</span></a></span></p>
<p class="copy"><span class="weblink"><a href="mailto:contact@greenhillbooks.com"><span class="underline">contact@greenhillbooks.com</span></a></span></p>
<p class="copy1">ISBN: 978-1-78438-503-3</p>
<p class="copy">eISBN: 978-1-78438-504-0</p>
<p class="copy">Mobi ISBN: 978-1-78438-505-7</p>
<p class="copy1"><span class="bold">Publishing History</span></p>
<p class="copy">First published in German in 2017 as</p>
<p class="copy"><em class="italic">Todesmarsch durch Russland: Mein Weg in die Kriegsgefangenschaft</em></p>
<p class="copy">by Edition Förg (Rosenheim).</p>
<p class="copy">This is the first English-language edition and includes a new foreword by Roger Moorhouse.</p>
<p class="copy1">All rights reserved.</p>
<p class="copy1">Klaus Willmann text © Edition Förg GmbH 2019</p>
<p class="copy">Roger Moorhouse foreword © Greenhill Books, 2019</p>
<p class="copy">Translation by Eva Burke © Greenhill Books, 2019</p>
<p class="copy1">The right of Klaus Willmann to be identified as author of this work has been asserted in accordance with Section 77 of the Copyrights Designs and Patents Act 1988.</p>
<p class="copy1">CIP data records for this title are available from the British Library</p>
<p class="copy1">Designed and typeset by Donald Sommerville</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?33512f64